module.exports = __webpack_public_path__ + "static/media/Avenir-BookOblique.aa0e2e73.ttf";